module.exports = __webpack_public_path__ + "static/media/sell_take_order_help_6.a39cadf0.png";